import connectToIDB from './../db/IDB';

class BaseModel {
  constructor(email, secretKey, isData = false) {
    this.db = connectToIDB(email, secretKey, isData);
  }
}

export default BaseModel;
